/**
 * Callback do login social com Google (Emergent-managed Auth).
 *
 * O Emergent Auth devolve o utilizador a esta rota com o session_id no
 * fragmento do URL: `/auth/social-callback?refer=123#session_id=xxx`.
 * Trocamos esse session_id no backend (que obtém o email/nome verificados,
 * autentica/cria o cliente e emite os cookies de sessão) e seguimos para /my.
 */
import { useEffect, useRef, useState } from "react";
import { SpinnerGap, WarningCircle } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function SocialCallback() {
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const refer = new URLSearchParams(window.location.search).get("refer");

    if (!sessionId) {
      setError("Sessão inválida. Volte a tentar iniciar sessão.");
      return;
    }

    api.post("/auth/google/finalize", { session_id: sessionId, refer })
      .then(({ data }) => {
        // Limpa o fragmento para não reprocessar e segue para o portal.
        window.history.replaceState(null, "", "/auth/social-callback");
        window.location.href = data?.redirect || "/my";
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || "Não foi possível concluir o login com Google.");
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#0F1829] flex items-center justify-center p-6 text-white" data-testid="social-callback">
      <div className="text-center max-w-md w-full">
        {error ? (
          <>
            <WarningCircle size={56} weight="fill" className="mx-auto mb-4 text-amber-400" />
            <p className="text-sm text-white/80 mb-5" data-testid="social-callback-error">{error}</p>
            <a href="/login" className="underline text-white/90 text-sm">Voltar ao login</a>
          </>
        ) : (
          <>
            <SpinnerGap size={40} className="animate-spin mx-auto mb-4" />
            <p className="text-sm text-white/70">A concluir o seu início de sessão…</p>
          </>
        )}
      </div>
    </div>
  );
}
